import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n  background-color: ', ';\n  padding: 32px;\n  border-bottom: 1px solid ', ';\n'], ['\n  background-color: ', ';\n  padding: 32px;\n  border-bottom: 1px solid ', ';\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  flex-direction: row;\n  display: flex;\n  align-items: center;\n  color: ', ';\n  font-size: ', ';\n  font-weight: 500;\n  line-height: 24px;\n  margin-bottom: ', ';\n'], ['\n  flex-direction: row;\n  display: flex;\n  align-items: center;\n  color: ', ';\n  font-size: ', ';\n  font-weight: 500;\n  line-height: 24px;\n  margin-bottom: ', ';\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  margin-right: 10px;\n'], ['\n  margin-right: 10px;\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  color: ', ';\n  font-size: ', ';\n  line-height: 24px;\n  font-weight: 400;\n'], ['\n  color: ', ';\n  font-size: ', ';\n  line-height: 24px;\n  font-weight: 400;\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n'], ['\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n']),
    _templateObject6 = _taggedTemplateLiteral(['\n  font-size: 13px;\n  margin-right: 12px;\n  background-color: ', ';\n  ', '\n  opacity: ', ';\n'], ['\n  font-size: 13px;\n  margin-right: 12px;\n  background-color: ', ';\n  ', '\n  opacity: ', ';\n']),
    _templateObject7 = _taggedTemplateLiteral(['\n      &:hover {\n        background-color: ', ';\n      }\n    '], ['\n      &:hover {\n        background-color: ', ';\n      }\n    ']),
    _templateObject8 = _taggedTemplateLiteral(['\n  font-size: 13px;\n  margin-left: 12px;\n  background-color: ', ';\n  ', '\n  opacity: ', ';\n'], ['\n  font-size: 13px;\n  margin-left: 12px;\n  background-color: ', ';\n  ', '\n  opacity: ', ';\n']),
    _templateObject9 = _taggedTemplateLiteral(['\n  height: 1px;\n  background-color: #d7d6de;\n  margin: 16px 0;\n'], ['\n  height: 1px;\n  background-color: #d7d6de;\n  margin: 16px 0;\n']);

import styled, { css } from 'styled-components';
import { styles } from 'gipsy-misc';
import Icon from '../../../../Icon';
import ReusableButton from '../../../../ReusableButton';

export var HeaderContainer = styled.div(_templateObject, function (props) {
  return props.backgroundColor ? props.backgroundColor : styles.colors.lightVioletColor;
}, styles.colors.borderColor);

export var Title = styled.div(_templateObject2, styles.colors.textDarkColor, styles.fonts.fontSize, function (props) {
  return props.nomargin ? '0px' : '24px';
});

export var Star = styled(Icon)(_templateObject3);

export var Description = styled.div(_templateObject4, styles.colors.textLightColor, styles.fonts.fontSizeSmall);

export var Actions = styled.div(_templateObject5);

export var ReopenButton = styled(ReusableButton)(_templateObject6, styles.colors.darkGrey, function (props) {
  return !props.disabled && css(_templateObject7, styles.colors.buttonDarkColorHover);
}, function (props) {
  return props.opacity ? props.opacity : 1;
});

export var ReviewButton = styled(ReusableButton)(_templateObject8, styles.colors.greenColor, function (props) {
  return !props.disabled && css(_templateObject7, styles.colors.greenDarkColor);
}, function (props) {
  return props.opacity ? props.opacity : 1;
});

export var Separator = styled.div(_templateObject9);
//# sourceMappingURL=Common.js.map


//////////////////
// WEBPACK FOOTER
// ../gipsy-ui/lib/TaskPanel/components/Header/Review/Common.js
// module id = 307
// module chunks = 0